import { render } from "./DailySpendChart.vue?vue&type=template&id=1ae62c0a&scoped=true"
import script from "./DailySpendChart.vue?vue&type=script&lang=js"
export * from "./DailySpendChart.vue?vue&type=script&lang=js"

import "./DailySpendChart.vue?vue&type=style&index=0&id=1ae62c0a&scoped=true&lang=css"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae62c0a"]])

export default __exports__